import request from './../request.js'

// 预存系列列表
export function preArchiveSeriesList(params){
    return request({
        url: 'preArchiveSeries/list.do?',
        method: 'post',
        data: params
    })
}

// 预存系列新增
export function addPreArchiveSeries(params){
    return request({
        url: 'preArchiveSeries/add.do?',
        method: 'post',
        data: params
    })
}

// 预存系列编辑
export function editPreArchiveSeries(params){
    return request({
        url: 'preArchiveSeries/edit.do?',
        method: 'post',
        data: params
    })
}

// 预存系列删除
export function deletePreArchiveSeries(params){
    return request({
        url: 'preArchiveSeries/delete.do?',
        method: 'post',
        data: params
    })
}

// 分配档位
export function assignAmount(params){
    return request({
        url: 'preArchiveSeries/assignAmount.do?',
        method: 'post',
        data: params
    })
}

// 档位列表
export function getAmountList(params){
    return request({
        url: 'preArchiveSeries/getAmountList.do?',
        method: 'post',
        data: params
    })
}

// 移除档位
export function removeAmount(params){
    return request({
        url: 'preArchiveSeries/removeAmount.do?',
        method: 'post',
        data: params
    })
}

// 公众号充值套餐获取
export function getPreArchiveAmounts(params){
    return request({
        url: 'https://iot.sunshineiot.net/traffic-weixin/card/getPreArchiveAmounts.do?',
        method: 'post',
        data: params
    })
}
